import { type Edition, useAuth } from './AuthContext';

export type { Edition };

/**
 * Returns the edition of the currently selected organization.
 * Defaults to 'professional' when no org is selected (e.g. during loading)
 * so the professional UI is shown by default.
 */
export function useEdition(): Edition {
  const { organization } = useAuth();
  return organization?.edition ?? 'professional';
}

export function useIsPersonalEdition(): boolean {
  return useEdition() === 'personal';
}
